import { render, staticRenderFns } from "./WaiversReview.vue?vue&type=template&id=394bf864&scoped=true&"
import script from "./WaiversReview.vue?vue&type=script&lang=js&"
export * from "./WaiversReview.vue?vue&type=script&lang=js&"
import style0 from "./WaiversReview.vue?vue&type=style&index=0&id=394bf864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394bf864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCheckbox,VDivider,VFlex,VForm,VLayout,VSpacer,VTextField})
